export const tracking_formatPaymentSubTypeForAnalytics = (
  paymentSubType: string,
) => {
  switch (paymentSubType) {
    case 'fixed_sum_credit':
      return `Delbetalning / ${paymentSubType}`;
    case 'invoice':
      return `Faktura / ${paymentSubType}`;
    case 'direct_debit':
      return `Bankkonto / ${paymentSubType}`;
    case 'direct_bank_transfer':
      return `Banköverföring / ${paymentSubType}`;
    case 'pay_by_card':
      return `Kort / ${paymentSubType}`;
    case 'alternative_payment_method':
      return `Swish / ${paymentSubType}`;
    case 'pay_later_by_card':
      return `Kort betala senare / ${paymentSubType}`;
    case 'slice_it_by_card':
      return `Delbetalning med kort / ${paymentSubType}`;
    default:
      return paymentSubType;
  }
};
